const isEmptyArray = (obj) => {
	return Array.isArray(obj) && obj.length === 0;
};

const zeroToNArray = (number) => {
	return [...Array(number).keys()];
};

const range = (size, startAt = 0) => {
	return [...Array(size).keys()].map((i) => i + startAt);
};

export { isEmptyArray, zeroToNArray, range };
